export {}


/**
 * 文字列クラス拡張定義
 */
declare global {
    interface String {
        /** 指定文字数以上の場合に、中略（「…」表示）する */
        ellipsis(length: number): string;
    }
}


/**
 * 指定文字数以上の場合に、中略（「…」表示）する
 */
String.prototype.ellipsis = function (this: string, length: number) {
    const cutLen = Math.max(1, length - 1)
    return (this.length < length) ? this : this.substr(0, cutLen) + "…"
}
